




















































import { Component, Vue, Watch } from "vue-property-decorator";
import AssetItem from "./AssetItem.vue";
import { Getter } from "vuex-class";
import { Asset } from "@foxone/api/src/models/wallet/mixin";

@Component({
  name: "assetSearch",
  components: {
    AssetItem
  }
})
class TopAssets extends Vue {
  @Getter("wallet/mixin/getMergedAssets") mergedAssets!: Asset[];

  dialog = false;

  filter = "";

  title = "";

  callback: any = "";

  notAddedAssets: Asset[] = [];

  searchedAssets: Asset[] = [];

  topAssets: Asset[] = [];

  loading = false;

  get assets() {
    if (this.filter) {
      return this.searchedAssets;
    }
    return this.notAddedAssets;
  }

  @Watch("dialog")
  handleDialogChange(val) {
    if (val) {
      this.requestTopAssets();
    }
  }

  @Watch("filter")
  handlerFilterChange = this.$common.utils.helper.throttle(
    () => this.requestSearchAssets(),
    50
  );

  handleClose() {
    this.filter = "";
    this.dialog = false;
  }

  handleToDetail(id) {
    this.handleClose();
    if (this.callback && typeof this.callback === "function") {
      this.callback(id);
      this.callback = "";
      this.title = "";
      return;
    }
    this.$helper.toFusionPath(this, "wallet", {
      name: "snapshots-id",
      params: { id }
    });
  }

  async requestSearchAssets() {
    this.loading = true;
    try {
      const data = await this.$api.wallet.mixin.searchAssets(this.filter);

      this.searchedAssets = data.map(asset => {
        const added = !!this.mergedAssets.find(
          x => x.asset_id === asset.asset_id
        );

        const chainAsset = this.topAssets.find(
          x => x.asset_id === asset.chain_id
        );

        return {
          added,
          logo: asset.icon_url,
          chainLogo: chainAsset && chainAsset.icon_url,
          ...asset
        };
      });
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }

  async requestTopAssets() {
    this.loading = true;
    try {
      const topAssets = await this.$api.wallet.mixin.getTopAssets();
      this.topAssets = topAssets;
      this.notAddedAssets = topAssets
        .filter(asset => {
          return !this.mergedAssets.find(x => x.asset_id === asset.asset_id);
        })
        .map(asset => {
          const added = this.mergedAssets.find(
            x => x.asset_id === asset.asset_id
          );

          const chainAsset = topAssets.find(x => x.asset_id === asset.chain_id);

          return {
            added,
            logo: asset.icon_url,
            chainLogo: chainAsset && chainAsset.icon_url,
            ...asset
          };
        });
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }
}
export default TopAssets;
